import Ambitus, {getAmbitusMarginInSemiTone} from "../../ambitus/Ambitus";

export interface TranspositionOption {
  id: number,
  tonality: string;
  semiToneOffset: number;
  isOriginalTone: boolean;
  difficulty: number;
  ambitus: Ambitus;
  score: number;
}

export function getTranspositionOptionsFromJson(json: any, songAmbitus: Ambitus): TranspositionOption[] {
  return json.slice()
    .sort((a: any, b: any) => a.semi_tone_offset - b.semi_tone_offset)
    .map((jsonTransposition: any) => {
      return {
        id: jsonTransposition.id,
        tonality: jsonTransposition.tonality,
        semiToneOffset: jsonTransposition.semi_tone_offset,
        isOriginalTone: jsonTransposition.semi_tone_offset === 0,
        difficulty: jsonTransposition.difficulty,
        ambitus: {
          high: songAmbitus.high + jsonTransposition.semi_tone_offset,
          low: songAmbitus.low + jsonTransposition.semi_tone_offset
        },
        score: 0
      }
    });
}
export function getTranspositionScore(transposition: TranspositionOption, userAmbitus: Ambitus): number {
  const ambitusMarginInSemiTone = getAmbitusMarginInSemiTone(transposition.ambitus, userAmbitus);
  const isAmbitusOk = ambitusMarginInSemiTone >= 0;
  const isAmbitusBest = ambitusMarginInSemiTone >= 4;

  let score = 0;
  if (isAmbitusBest) {
    if (transposition.difficulty === 1) {
      score += 100;
    }
    else if (transposition.difficulty === 2) {
      score += 50;
    }
    else if (transposition.difficulty === 3) {
      score += 20;
    }
    score += ambitusMarginInSemiTone;
  }
  else if (isAmbitusOk) {
    if (transposition.difficulty === 1) {
      score += 75;
    }
    else if (transposition.difficulty === 2) {
      score += 25;
    }
    else if (transposition.difficulty === 3) {
      score += 10;
    }
    score += ambitusMarginInSemiTone;
  }

  if (transposition.isOriginalTone) {
    score += isAmbitusOk ? 200 : 1;
  }

  return score;
}
